import React, { FC } from 'react'

import { Text } from '@ucheba/ui/components/Text/desktop'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { p11n } from '@ucheba/utils/helpers/string'

import ArrowRightIcon from '@ucheba/ui/icons/icon__arrow-right_circle-outline.svg'

import { IButtonAssessmentOfChancesProps } from '../types'
import { HEAD_COLORS, PROBABILITY_TYPES } from '../constants'
import { Container, RestartIconButton, Content } from '../styles'

import { useButtonAssessmentOfChances } from './bll'

const ButtonAssessmentOfChances: FC<IButtonAssessmentOfChancesProps> = (props) => {
  const { restartAssessmentOfChances, openResultList, size = 'medium' } = props

  const {
    probability,
    handleAssessmentOfChances,
    countPrograms,
    currentProbability,
    handleGetResultList,
    isAuth,
    isRender,
    chancesOfAdmissionLoading,
  } = useButtonAssessmentOfChances(openResultList, restartAssessmentOfChances)

  if (!isRender) return null

  if (!currentProbability || !isAuth) {
    return (
      <Button
        progress={chancesOfAdmissionLoading}
        color='blue'
        block
        onClick={handleAssessmentOfChances}
      >
        Оценить шансы
      </Button>
    )
  }

  return (
    <Container
      mainColor={HEAD_COLORS[probability].box}
      textColor={HEAD_COLORS[probability].buttonHover}
    >
      <Content>
        <Text
          firstLetterUppercase
          color={HEAD_COLORS[probability].heading}
          fontSize={size === 'small' ? 'h4' : 'h3'}
          lineHeight={size === 'small' ? 'h4' : 'h3'}
          fontWeight='extrabold'
        >
          {`${PROBABILITY_TYPES[probability]} шансы поступить`}
        </Text>

        <RestartIconButton
          color={HEAD_COLORS[probability].heading}
          onClick={handleAssessmentOfChances}
        />
      </Content>

      <Button
        block
        view='link'
        justifyContent='space-between'
        onClick={handleGetResultList}
        EndIcon={<ArrowRightIcon />}
        color={HEAD_COLORS[probability].heading}
        size={size}
      >
        {countPrograms} {p11n(countPrograms || 0, 'программа', 'программы', 'программ')}
      </Button>
    </Container>
  )
}

export default ButtonAssessmentOfChances
